/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createOrderrDraft = /* GraphQL */ `
  mutation CreateOrderrDraft($input: CreateOrderrDraftIn) {
    createOrderrDraft(input: $input) {
      id
      mssId
      mobVersion
      groups
      appInstance
      bookingState
      orderrNumber
      price
      priceWithoutDph
      dph
      deposit
      itemsCount
      expireAt
      datePickUp
      dateReturn
      dateTryOut
      paymentMethod
      description
      rentDiscountPercent
      schoolDiscountPercent
      discountCode
      language
      createdAt
      updatedAt
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        orderNumber
        email
        note
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      client {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        age
        gender
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      payments {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          mssOrderrId
          paymentMethod
          paymentState
          amount
          currency
          transId
          redirectUrl
          expirationNotified
          createdAt
          updatedAt
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const addToCart = /* GraphQL */ `
  mutation AddToCart($input: AddToCartIn) {
    addToCart(input: $input) {
      id
      mssId
      mobVersion
      groups
      appInstance
      bookingState
      orderrNumber
      price
      priceWithoutDph
      dph
      deposit
      itemsCount
      expireAt
      datePickUp
      dateReturn
      dateTryOut
      paymentMethod
      description
      rentDiscountPercent
      schoolDiscountPercent
      discountCode
      language
      createdAt
      updatedAt
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        orderNumber
        email
        note
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      client {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        age
        gender
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      payments {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          mssOrderrId
          paymentMethod
          paymentState
          amount
          currency
          transId
          redirectUrl
          expirationNotified
          createdAt
          updatedAt
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const removeFromCart = /* GraphQL */ `
  mutation RemoveFromCart($orderrItemGroupId: ID!) {
    removeFromCart(orderrItemGroupId: $orderrItemGroupId) {
      id
      mssId
      mobVersion
      groups
      appInstance
      bookingState
      orderrNumber
      price
      priceWithoutDph
      dph
      deposit
      itemsCount
      expireAt
      datePickUp
      dateReturn
      dateTryOut
      paymentMethod
      description
      rentDiscountPercent
      schoolDiscountPercent
      discountCode
      language
      createdAt
      updatedAt
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        orderNumber
        email
        note
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      client {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        age
        gender
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      payments {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          mssOrderrId
          paymentMethod
          paymentState
          amount
          currency
          transId
          redirectUrl
          expirationNotified
          createdAt
          updatedAt
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const initMOB = /* GraphQL */ `
  mutation InitMOB($appInstance: String, $mobVersion: Int) {
    initMOB(appInstance: $appInstance, mobVersion: $mobVersion)
  }
`;
export const updateOrderrPickupAndPaymentInfo = /* GraphQL */ `
  mutation UpdateOrderrPickupAndPaymentInfo(
    $orderrId: ID!
    $datePickUp: AWSDateTime!
    $paymentMethod: PaymentMethod!
    $dateTryOut: AWSDateTime
    $description: String
  ) {
    updateOrderrPickupAndPaymentInfo(
      orderrId: $orderrId
      datePickUp: $datePickUp
      paymentMethod: $paymentMethod
      dateTryOut: $dateTryOut
      description: $description
    ) {
      id
      mssId
      mobVersion
      groups
      appInstance
      bookingState
      orderrNumber
      price
      priceWithoutDph
      dph
      deposit
      itemsCount
      expireAt
      datePickUp
      dateReturn
      dateTryOut
      paymentMethod
      description
      rentDiscountPercent
      schoolDiscountPercent
      discountCode
      language
      createdAt
      updatedAt
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        orderNumber
        email
        note
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      client {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        age
        gender
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      payments {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          mssOrderrId
          paymentMethod
          paymentState
          amount
          currency
          transId
          redirectUrl
          expirationNotified
          createdAt
          updatedAt
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const checkoutOrderr = /* GraphQL */ `
  mutation CheckoutOrderr($orderrId: ID!, $subjectIn: SubjectIn!) {
    checkoutOrderr(orderrId: $orderrId, subjectIn: $subjectIn) {
      id
      mssId
      mobVersion
      groups
      appInstance
      bookingState
      orderrNumber
      price
      priceWithoutDph
      dph
      deposit
      itemsCount
      expireAt
      datePickUp
      dateReturn
      dateTryOut
      paymentMethod
      description
      rentDiscountPercent
      schoolDiscountPercent
      discountCode
      language
      createdAt
      updatedAt
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        orderNumber
        email
        note
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      client {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        age
        gender
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      payments {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          mssOrderrId
          paymentMethod
          paymentState
          amount
          currency
          transId
          redirectUrl
          expirationNotified
          createdAt
          updatedAt
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const applyDiscountCode = /* GraphQL */ `
  mutation ApplyDiscountCode($orderrId: ID!, $code: String!) {
    applyDiscountCode(orderrId: $orderrId, code: $code) {
      id
      mssId
      mobVersion
      groups
      appInstance
      bookingState
      orderrNumber
      price
      priceWithoutDph
      dph
      deposit
      itemsCount
      expireAt
      datePickUp
      dateReturn
      dateTryOut
      paymentMethod
      description
      rentDiscountPercent
      schoolDiscountPercent
      discountCode
      language
      createdAt
      updatedAt
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        orderNumber
        email
        note
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      client {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        age
        gender
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      payments {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          mssOrderrId
          paymentMethod
          paymentState
          amount
          currency
          transId
          redirectUrl
          expirationNotified
          createdAt
          updatedAt
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const removeDiscountCode = /* GraphQL */ `
  mutation RemoveDiscountCode($orderrId: ID!) {
    removeDiscountCode(orderrId: $orderrId) {
      id
      mssId
      mobVersion
      groups
      appInstance
      bookingState
      orderrNumber
      price
      priceWithoutDph
      dph
      deposit
      itemsCount
      expireAt
      datePickUp
      dateReturn
      dateTryOut
      paymentMethod
      description
      rentDiscountPercent
      schoolDiscountPercent
      discountCode
      language
      createdAt
      updatedAt
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        orderNumber
        email
        note
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      client {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        age
        gender
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      payments {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          mssOrderrId
          paymentMethod
          paymentState
          amount
          currency
          transId
          redirectUrl
          expirationNotified
          createdAt
          updatedAt
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const sendCourseInquiry = /* GraphQL */ `
  mutation SendCourseInquiry(
    $appInstance: String!
    $mobVersion: Int!
    $locale: String!
    $courseInquiryPayload: CourseInquiryPayload!
  ) {
    sendCourseInquiry(
      appInstance: $appInstance
      mobVersion: $mobVersion
      locale: $locale
      courseInquiryPayload: $courseInquiryPayload
    )
  }
`;
export const debug = /* GraphQL */ `
  mutation Debug($input: String) {
    debug(input: $input)
  }
`;
export const createRentProductRequirement = /* GraphQL */ `
  mutation CreateRentProductRequirement(
    $input: CreateRentProductRequirementInput!
    $condition: ModelRentProductRequirementConditionInput
  ) {
    createRentProductRequirement(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      rentProductType
      nameDisplayed
      nameRequired
      sexDisplayed
      sexRequired
      ageDisplayed
      ageRequired
      weightDisplayed
      weightRequired
      heightDisplayed
      heightRequired
      shoeSizeDisplayed
      shoeSizeRequired
      rentAbilityLevelDisplayed
      rentAbilityLevelRequired
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRentProductRequirement = /* GraphQL */ `
  mutation UpdateRentProductRequirement(
    $input: UpdateRentProductRequirementInput!
    $condition: ModelRentProductRequirementConditionInput
  ) {
    updateRentProductRequirement(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      rentProductType
      nameDisplayed
      nameRequired
      sexDisplayed
      sexRequired
      ageDisplayed
      ageRequired
      weightDisplayed
      weightRequired
      heightDisplayed
      heightRequired
      shoeSizeDisplayed
      shoeSizeRequired
      rentAbilityLevelDisplayed
      rentAbilityLevelRequired
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRentProductRequirement = /* GraphQL */ `
  mutation DeleteRentProductRequirement(
    $input: DeleteRentProductRequirementInput!
    $condition: ModelRentProductRequirementConditionInput
  ) {
    deleteRentProductRequirement(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      rentProductType
      nameDisplayed
      nameRequired
      sexDisplayed
      sexRequired
      ageDisplayed
      ageRequired
      weightDisplayed
      weightRequired
      heightDisplayed
      heightRequired
      shoeSizeDisplayed
      shoeSizeRequired
      rentAbilityLevelDisplayed
      rentAbilityLevelRequired
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAgeGroup = /* GraphQL */ `
  mutation CreateAgeGroup(
    $input: CreateAgeGroupInput!
    $condition: ModelAgeGroupConditionInput
  ) {
    createAgeGroup(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      ageFrom
      ageTo
      createdAt
      updatedAt
      products {
        items {
          id
          productId
          ageGroupId
          createdAt
          updatedAt
          ageGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            ageFrom
            ageTo
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateAgeGroup = /* GraphQL */ `
  mutation UpdateAgeGroup(
    $input: UpdateAgeGroupInput!
    $condition: ModelAgeGroupConditionInput
  ) {
    updateAgeGroup(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      ageFrom
      ageTo
      createdAt
      updatedAt
      products {
        items {
          id
          productId
          ageGroupId
          createdAt
          updatedAt
          ageGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            ageFrom
            ageTo
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteAgeGroup = /* GraphQL */ `
  mutation DeleteAgeGroup(
    $input: DeleteAgeGroupInput!
    $condition: ModelAgeGroupConditionInput
  ) {
    deleteAgeGroup(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      ageFrom
      ageTo
      createdAt
      updatedAt
      products {
        items {
          id
          productId
          ageGroupId
          createdAt
          updatedAt
          ageGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            ageFrom
            ageTo
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createProductAgeGroup = /* GraphQL */ `
  mutation CreateProductAgeGroup(
    $input: CreateProductAgeGroupInput!
    $condition: ModelProductAgeGroupConditionInput
  ) {
    createProductAgeGroup(input: $input, condition: $condition) {
      id
      productId
      ageGroupId
      createdAt
      updatedAt
      ageGroup {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        ageFrom
        ageTo
        createdAt
        updatedAt
        products {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateProductAgeGroup = /* GraphQL */ `
  mutation UpdateProductAgeGroup(
    $input: UpdateProductAgeGroupInput!
    $condition: ModelProductAgeGroupConditionInput
  ) {
    updateProductAgeGroup(input: $input, condition: $condition) {
      id
      productId
      ageGroupId
      createdAt
      updatedAt
      ageGroup {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        ageFrom
        ageTo
        createdAt
        updatedAt
        products {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteProductAgeGroup = /* GraphQL */ `
  mutation DeleteProductAgeGroup(
    $input: DeleteProductAgeGroupInput!
    $condition: ModelProductAgeGroupConditionInput
  ) {
    deleteProductAgeGroup(input: $input, condition: $condition) {
      id
      productId
      ageGroupId
      createdAt
      updatedAt
      ageGroup {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        ageFrom
        ageTo
        createdAt
        updatedAt
        products {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createMOBConfig = /* GraphQL */ `
  mutation CreateMOBConfig(
    $input: CreateMOBConfigInput!
    $condition: ModelMOBConfigConditionInput
  ) {
    createMOBConfig(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mobDeploymentId
      enabled
      enabledSchool
      enabledRent
      companyName
      title
      schoolHeader
      rentHeader
      schoolClaim
      rentClaim
      rentVop
      schoolVop
      schoolBookingOffset
      schoolGroupBookingOffset
      schoolCampBookingOffset
      rentBookingOffsetHours
      rentBookingOffset
      checkoutTimeLimit
      showPriceWithoutDPH
      rentDiscountPercent
      schoolDiscountPercent
      email
      phone
      emailNotifLogoUrl
      websiteUrl
      webLogoUrl
      webLogoSmallUrl
      webHeroBgImgUrl
      productImageRatio
      paymentMethods
      currency
      cartStaticInfo
      checkoutStaticInfo
      introText
      emailText
      emailTextSchool
      emailTextRent
      lowSeasons {
        from
        to
        __typename
      }
      discountCodeImplementation
      generalTermsConditionsURL
      rentalSetsEnabled
      rentalDisplaySizesEnabled
      displayGeneralPrices
      displayPickUpDate
      schoolPointMeetingInfo
      schoolPointMeetingUrl
      schoolSkillLevelClientInfo
      schoolSkillLevelClientURL
      sganttSlotTimeLengthReductions {
        sganttSlotType
        defaultReduction
        reductions {
          timeLengthInHours
          reductionInMinutes
          __typename
        }
        __typename
      }
      mobRentIcon
      mobSchoolIcon
      locales
      defaultLocale
      courseLanguages
      courseGroupClientLanguages
      coursePrivateClientLanguages
      courseGroupIsWholeDayRequired
      rentSelectSizeAutomatic
      shoeSizeItems
      rentDisabledPointSells
      rentDatePickTryOutEnabled
      deliveryPoints
      rentProductCardImgHeightXs
      rentProductCardImgHeightSm
      rentProductCardImgHeightMd
      rentProductCardImgHeightLg
      rentProductCardImgHeightXl
      rentSearchSmCols
      rentSearchMdCols
      rentSearchLgCols
      rentProductCardImgAspectRatio
      useV2SchoolAvailability
      gaTrackingId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateMOBConfig = /* GraphQL */ `
  mutation UpdateMOBConfig(
    $input: UpdateMOBConfigInput!
    $condition: ModelMOBConfigConditionInput
  ) {
    updateMOBConfig(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mobDeploymentId
      enabled
      enabledSchool
      enabledRent
      companyName
      title
      schoolHeader
      rentHeader
      schoolClaim
      rentClaim
      rentVop
      schoolVop
      schoolBookingOffset
      schoolGroupBookingOffset
      schoolCampBookingOffset
      rentBookingOffsetHours
      rentBookingOffset
      checkoutTimeLimit
      showPriceWithoutDPH
      rentDiscountPercent
      schoolDiscountPercent
      email
      phone
      emailNotifLogoUrl
      websiteUrl
      webLogoUrl
      webLogoSmallUrl
      webHeroBgImgUrl
      productImageRatio
      paymentMethods
      currency
      cartStaticInfo
      checkoutStaticInfo
      introText
      emailText
      emailTextSchool
      emailTextRent
      lowSeasons {
        from
        to
        __typename
      }
      discountCodeImplementation
      generalTermsConditionsURL
      rentalSetsEnabled
      rentalDisplaySizesEnabled
      displayGeneralPrices
      displayPickUpDate
      schoolPointMeetingInfo
      schoolPointMeetingUrl
      schoolSkillLevelClientInfo
      schoolSkillLevelClientURL
      sganttSlotTimeLengthReductions {
        sganttSlotType
        defaultReduction
        reductions {
          timeLengthInHours
          reductionInMinutes
          __typename
        }
        __typename
      }
      mobRentIcon
      mobSchoolIcon
      locales
      defaultLocale
      courseLanguages
      courseGroupClientLanguages
      coursePrivateClientLanguages
      courseGroupIsWholeDayRequired
      rentSelectSizeAutomatic
      shoeSizeItems
      rentDisabledPointSells
      rentDatePickTryOutEnabled
      deliveryPoints
      rentProductCardImgHeightXs
      rentProductCardImgHeightSm
      rentProductCardImgHeightMd
      rentProductCardImgHeightLg
      rentProductCardImgHeightXl
      rentSearchSmCols
      rentSearchMdCols
      rentSearchLgCols
      rentProductCardImgAspectRatio
      useV2SchoolAvailability
      gaTrackingId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteMOBConfig = /* GraphQL */ `
  mutation DeleteMOBConfig(
    $input: DeleteMOBConfigInput!
    $condition: ModelMOBConfigConditionInput
  ) {
    deleteMOBConfig(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mobDeploymentId
      enabled
      enabledSchool
      enabledRent
      companyName
      title
      schoolHeader
      rentHeader
      schoolClaim
      rentClaim
      rentVop
      schoolVop
      schoolBookingOffset
      schoolGroupBookingOffset
      schoolCampBookingOffset
      rentBookingOffsetHours
      rentBookingOffset
      checkoutTimeLimit
      showPriceWithoutDPH
      rentDiscountPercent
      schoolDiscountPercent
      email
      phone
      emailNotifLogoUrl
      websiteUrl
      webLogoUrl
      webLogoSmallUrl
      webHeroBgImgUrl
      productImageRatio
      paymentMethods
      currency
      cartStaticInfo
      checkoutStaticInfo
      introText
      emailText
      emailTextSchool
      emailTextRent
      lowSeasons {
        from
        to
        __typename
      }
      discountCodeImplementation
      generalTermsConditionsURL
      rentalSetsEnabled
      rentalDisplaySizesEnabled
      displayGeneralPrices
      displayPickUpDate
      schoolPointMeetingInfo
      schoolPointMeetingUrl
      schoolSkillLevelClientInfo
      schoolSkillLevelClientURL
      sganttSlotTimeLengthReductions {
        sganttSlotType
        defaultReduction
        reductions {
          timeLengthInHours
          reductionInMinutes
          __typename
        }
        __typename
      }
      mobRentIcon
      mobSchoolIcon
      locales
      defaultLocale
      courseLanguages
      courseGroupClientLanguages
      coursePrivateClientLanguages
      courseGroupIsWholeDayRequired
      rentSelectSizeAutomatic
      shoeSizeItems
      rentDisabledPointSells
      rentDatePickTryOutEnabled
      deliveryPoints
      rentProductCardImgHeightXs
      rentProductCardImgHeightSm
      rentProductCardImgHeightMd
      rentProductCardImgHeightLg
      rentProductCardImgHeightXl
      rentSearchSmCols
      rentSearchMdCols
      rentSearchLgCols
      rentProductCardImgAspectRatio
      useV2SchoolAvailability
      gaTrackingId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createStaticContent = /* GraphQL */ `
  mutation CreateStaticContent(
    $input: CreateStaticContentInput!
    $condition: ModelStaticContentConditionInput
  ) {
    createStaticContent(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      title
      icon
      isExternal
      linkUrl
      content
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateStaticContent = /* GraphQL */ `
  mutation UpdateStaticContent(
    $input: UpdateStaticContentInput!
    $condition: ModelStaticContentConditionInput
  ) {
    updateStaticContent(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      title
      icon
      isExternal
      linkUrl
      content
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteStaticContent = /* GraphQL */ `
  mutation DeleteStaticContent(
    $input: DeleteStaticContentInput!
    $condition: ModelStaticContentConditionInput
  ) {
    deleteStaticContent(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      title
      icon
      isExternal
      linkUrl
      content
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSkill = /* GraphQL */ `
  mutation CreateSkill(
    $input: CreateSkillInput!
    $condition: ModelSkillConditionInput
  ) {
    createSkill(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateSkill = /* GraphQL */ `
  mutation UpdateSkill(
    $input: UpdateSkillInput!
    $condition: ModelSkillConditionInput
  ) {
    updateSkill(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteSkill = /* GraphQL */ `
  mutation DeleteSkill(
    $input: DeleteSkillInput!
    $condition: ModelSkillConditionInput
  ) {
    deleteSkill(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createSkillLevelClient = /* GraphQL */ `
  mutation CreateSkillLevelClient(
    $input: CreateSkillLevelClientInput!
    $condition: ModelSkillLevelClientConditionInput
  ) {
    createSkillLevelClient(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      name
      description
      orderNumber
      codeSkillLevelClient
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          productId
          skillLevelClientId
          length
          startTime
          createdAt
          updatedAt
          skillLevelClient {
            id
            mobVersion
            groups
            appInstance
            mssId
            name
            description
            orderNumber
            codeSkillLevelClient
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          article {
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            __typename
          }
          language
          languages
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
            __typename
          }
          groupCourse {
            id
            mobVersion
            appInstance
            mssId
            title
            description
            pointMeetingMssId
            dateFrom
            dateTo
            availableCapacity
            hoursPerDay
            minLength
            skillLevelClientId
            allowGroupCourseFlexibleStart
            price
            __typename
          }
          groupCourseDateStart
          groupCourseLessons {
            id
            mobVersion
            appInstance
            mssId
            timeFrom
            timeTo
            availableCapacity
            __typename
          }
          price
          priceWithoutDph
          dph
          dphPercent
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          priceListType
          createdAt
          updatedAt
          skillLevelClient {
            id
            mobVersion
            groups
            appInstance
            mssId
            name
            description
            orderNumber
            codeSkillLevelClient
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateSkillLevelClient = /* GraphQL */ `
  mutation UpdateSkillLevelClient(
    $input: UpdateSkillLevelClientInput!
    $condition: ModelSkillLevelClientConditionInput
  ) {
    updateSkillLevelClient(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      name
      description
      orderNumber
      codeSkillLevelClient
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          productId
          skillLevelClientId
          length
          startTime
          createdAt
          updatedAt
          skillLevelClient {
            id
            mobVersion
            groups
            appInstance
            mssId
            name
            description
            orderNumber
            codeSkillLevelClient
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          article {
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            __typename
          }
          language
          languages
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
            __typename
          }
          groupCourse {
            id
            mobVersion
            appInstance
            mssId
            title
            description
            pointMeetingMssId
            dateFrom
            dateTo
            availableCapacity
            hoursPerDay
            minLength
            skillLevelClientId
            allowGroupCourseFlexibleStart
            price
            __typename
          }
          groupCourseDateStart
          groupCourseLessons {
            id
            mobVersion
            appInstance
            mssId
            timeFrom
            timeTo
            availableCapacity
            __typename
          }
          price
          priceWithoutDph
          dph
          dphPercent
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          priceListType
          createdAt
          updatedAt
          skillLevelClient {
            id
            mobVersion
            groups
            appInstance
            mssId
            name
            description
            orderNumber
            codeSkillLevelClient
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteSkillLevelClient = /* GraphQL */ `
  mutation DeleteSkillLevelClient(
    $input: DeleteSkillLevelClientInput!
    $condition: ModelSkillLevelClientConditionInput
  ) {
    deleteSkillLevelClient(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      name
      description
      orderNumber
      codeSkillLevelClient
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          productId
          skillLevelClientId
          length
          startTime
          createdAt
          updatedAt
          skillLevelClient {
            id
            mobVersion
            groups
            appInstance
            mssId
            name
            description
            orderNumber
            codeSkillLevelClient
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          article {
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            __typename
          }
          language
          languages
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
            __typename
          }
          groupCourse {
            id
            mobVersion
            appInstance
            mssId
            title
            description
            pointMeetingMssId
            dateFrom
            dateTo
            availableCapacity
            hoursPerDay
            minLength
            skillLevelClientId
            allowGroupCourseFlexibleStart
            price
            __typename
          }
          groupCourseDateStart
          groupCourseLessons {
            id
            mobVersion
            appInstance
            mssId
            timeFrom
            timeTo
            availableCapacity
            __typename
          }
          price
          priceWithoutDph
          dph
          dphPercent
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          priceListType
          createdAt
          updatedAt
          skillLevelClient {
            id
            mobVersion
            groups
            appInstance
            mssId
            name
            description
            orderNumber
            codeSkillLevelClient
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createProductSkillLevelClient = /* GraphQL */ `
  mutation CreateProductSkillLevelClient(
    $input: CreateProductSkillLevelClientInput!
    $condition: ModelProductSkillLevelClientConditionInput
  ) {
    createProductSkillLevelClient(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      productId
      skillLevelClientId
      length
      startTime
      createdAt
      updatedAt
      skillLevelClient {
        id
        mobVersion
        groups
        appInstance
        mssId
        name
        description
        orderNumber
        codeSkillLevelClient
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateProductSkillLevelClient = /* GraphQL */ `
  mutation UpdateProductSkillLevelClient(
    $input: UpdateProductSkillLevelClientInput!
    $condition: ModelProductSkillLevelClientConditionInput
  ) {
    updateProductSkillLevelClient(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      productId
      skillLevelClientId
      length
      startTime
      createdAt
      updatedAt
      skillLevelClient {
        id
        mobVersion
        groups
        appInstance
        mssId
        name
        description
        orderNumber
        codeSkillLevelClient
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteProductSkillLevelClient = /* GraphQL */ `
  mutation DeleteProductSkillLevelClient(
    $input: DeleteProductSkillLevelClientInput!
    $condition: ModelProductSkillLevelClientConditionInput
  ) {
    deleteProductSkillLevelClient(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      productId
      skillLevelClientId
      length
      startTime
      createdAt
      updatedAt
      skillLevelClient {
        id
        mobVersion
        groups
        appInstance
        mssId
        name
        description
        orderNumber
        codeSkillLevelClient
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createProduct = /* GraphQL */ `
  mutation CreateProduct(
    $input: CreateProductInput!
    $condition: ModelProductConditionInput
  ) {
    createProduct(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      intro
      description
      productType
      enabledFrom
      enabledTo
      pricingMode
      priceListType
      priceTables {
        mssId
        numberOfPersons
        priceListType
        isLowSeason
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
        __typename
      }
      alternativePriceLists {
        mssId
        numberOfPersons
        priceListType
        isLowSeason
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
        __typename
      }
      images
      sizes
      deposit
      orderNumber
      rentProductType
      rentAvailabilityMode
      rentAllowedLengths {
        length
        unit
        __typename
      }
      schoolFormType
      numberOfPersons
      minNumOfPersons
      maxNumOfPersons
      minLessonLength
      maxLessonLength
      defaultLessonLength
      minLength
      maxLength
      minDailyLength
      maxDailyLength
      defaultDailyLength
      allowGroupCourseFlexibleStart
      groupCourseCustomLessonSelection
      timePreferencesStartTimes
      timePreferencesEnabledMonday
      timePreferencesEnabledTuesday
      timePreferencesEnabledWednesday
      timePreferencesEnabledThursday
      timePreferencesEnabledFriday
      timePreferencesEnabledSaturday
      timePreferencesEnabledSunday
      hidden
      campCourse
      textEmail
      customFormSchema
      createdAt
      updatedAt
      ageGroups {
        items {
          id
          productId
          ageGroupId
          createdAt
          updatedAt
          ageGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            ageFrom
            ageTo
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      skill {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      skillLevelClients {
        items {
          id
          mobVersion
          groups
          appInstance
          productId
          skillLevelClientId
          length
          startTime
          createdAt
          updatedAt
          skillLevelClient {
            id
            mobVersion
            groups
            appInstance
            mssId
            name
            description
            orderNumber
            codeSkillLevelClient
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      masterProduct {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      childProducts {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      category {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        orderNumber
        campCourse
        hidden
        rentalSet
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      locations {
        items {
          id
          mobVersion
          productId
          locationId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      pointMeetings {
        items {
          id
          mobVersion
          groups
          appInstance
          pointMeetingId
          productId
          orderNumber
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      sets {
        items {
          id
          mobVersion
          groups
          appInstance
          setId
          productId
          orderNumber
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      productPackets {
        items {
          id
          mobVersion
          groups
          appInstance
          productPacketId
          productId
          orderNumber
          preselected
          required
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          article {
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            __typename
          }
          language
          languages
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
            __typename
          }
          groupCourse {
            id
            mobVersion
            appInstance
            mssId
            title
            description
            pointMeetingMssId
            dateFrom
            dateTo
            availableCapacity
            hoursPerDay
            minLength
            skillLevelClientId
            allowGroupCourseFlexibleStart
            price
            __typename
          }
          groupCourseDateStart
          groupCourseLessons {
            id
            mobVersion
            appInstance
            mssId
            timeFrom
            timeTo
            availableCapacity
            __typename
          }
          price
          priceWithoutDph
          dph
          dphPercent
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          priceListType
          createdAt
          updatedAt
          skillLevelClient {
            id
            mobVersion
            groups
            appInstance
            mssId
            name
            description
            orderNumber
            codeSkillLevelClient
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateProduct = /* GraphQL */ `
  mutation UpdateProduct(
    $input: UpdateProductInput!
    $condition: ModelProductConditionInput
  ) {
    updateProduct(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      intro
      description
      productType
      enabledFrom
      enabledTo
      pricingMode
      priceListType
      priceTables {
        mssId
        numberOfPersons
        priceListType
        isLowSeason
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
        __typename
      }
      alternativePriceLists {
        mssId
        numberOfPersons
        priceListType
        isLowSeason
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
        __typename
      }
      images
      sizes
      deposit
      orderNumber
      rentProductType
      rentAvailabilityMode
      rentAllowedLengths {
        length
        unit
        __typename
      }
      schoolFormType
      numberOfPersons
      minNumOfPersons
      maxNumOfPersons
      minLessonLength
      maxLessonLength
      defaultLessonLength
      minLength
      maxLength
      minDailyLength
      maxDailyLength
      defaultDailyLength
      allowGroupCourseFlexibleStart
      groupCourseCustomLessonSelection
      timePreferencesStartTimes
      timePreferencesEnabledMonday
      timePreferencesEnabledTuesday
      timePreferencesEnabledWednesday
      timePreferencesEnabledThursday
      timePreferencesEnabledFriday
      timePreferencesEnabledSaturday
      timePreferencesEnabledSunday
      hidden
      campCourse
      textEmail
      customFormSchema
      createdAt
      updatedAt
      ageGroups {
        items {
          id
          productId
          ageGroupId
          createdAt
          updatedAt
          ageGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            ageFrom
            ageTo
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      skill {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      skillLevelClients {
        items {
          id
          mobVersion
          groups
          appInstance
          productId
          skillLevelClientId
          length
          startTime
          createdAt
          updatedAt
          skillLevelClient {
            id
            mobVersion
            groups
            appInstance
            mssId
            name
            description
            orderNumber
            codeSkillLevelClient
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      masterProduct {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      childProducts {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      category {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        orderNumber
        campCourse
        hidden
        rentalSet
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      locations {
        items {
          id
          mobVersion
          productId
          locationId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      pointMeetings {
        items {
          id
          mobVersion
          groups
          appInstance
          pointMeetingId
          productId
          orderNumber
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      sets {
        items {
          id
          mobVersion
          groups
          appInstance
          setId
          productId
          orderNumber
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      productPackets {
        items {
          id
          mobVersion
          groups
          appInstance
          productPacketId
          productId
          orderNumber
          preselected
          required
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          article {
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            __typename
          }
          language
          languages
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
            __typename
          }
          groupCourse {
            id
            mobVersion
            appInstance
            mssId
            title
            description
            pointMeetingMssId
            dateFrom
            dateTo
            availableCapacity
            hoursPerDay
            minLength
            skillLevelClientId
            allowGroupCourseFlexibleStart
            price
            __typename
          }
          groupCourseDateStart
          groupCourseLessons {
            id
            mobVersion
            appInstance
            mssId
            timeFrom
            timeTo
            availableCapacity
            __typename
          }
          price
          priceWithoutDph
          dph
          dphPercent
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          priceListType
          createdAt
          updatedAt
          skillLevelClient {
            id
            mobVersion
            groups
            appInstance
            mssId
            name
            description
            orderNumber
            codeSkillLevelClient
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteProduct = /* GraphQL */ `
  mutation DeleteProduct(
    $input: DeleteProductInput!
    $condition: ModelProductConditionInput
  ) {
    deleteProduct(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      intro
      description
      productType
      enabledFrom
      enabledTo
      pricingMode
      priceListType
      priceTables {
        mssId
        numberOfPersons
        priceListType
        isLowSeason
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
        __typename
      }
      alternativePriceLists {
        mssId
        numberOfPersons
        priceListType
        isLowSeason
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
        __typename
      }
      images
      sizes
      deposit
      orderNumber
      rentProductType
      rentAvailabilityMode
      rentAllowedLengths {
        length
        unit
        __typename
      }
      schoolFormType
      numberOfPersons
      minNumOfPersons
      maxNumOfPersons
      minLessonLength
      maxLessonLength
      defaultLessonLength
      minLength
      maxLength
      minDailyLength
      maxDailyLength
      defaultDailyLength
      allowGroupCourseFlexibleStart
      groupCourseCustomLessonSelection
      timePreferencesStartTimes
      timePreferencesEnabledMonday
      timePreferencesEnabledTuesday
      timePreferencesEnabledWednesday
      timePreferencesEnabledThursday
      timePreferencesEnabledFriday
      timePreferencesEnabledSaturday
      timePreferencesEnabledSunday
      hidden
      campCourse
      textEmail
      customFormSchema
      createdAt
      updatedAt
      ageGroups {
        items {
          id
          productId
          ageGroupId
          createdAt
          updatedAt
          ageGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            ageFrom
            ageTo
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      skill {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      skillLevelClients {
        items {
          id
          mobVersion
          groups
          appInstance
          productId
          skillLevelClientId
          length
          startTime
          createdAt
          updatedAt
          skillLevelClient {
            id
            mobVersion
            groups
            appInstance
            mssId
            name
            description
            orderNumber
            codeSkillLevelClient
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      masterProduct {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      childProducts {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      category {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        orderNumber
        campCourse
        hidden
        rentalSet
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      locations {
        items {
          id
          mobVersion
          productId
          locationId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      pointMeetings {
        items {
          id
          mobVersion
          groups
          appInstance
          pointMeetingId
          productId
          orderNumber
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      sets {
        items {
          id
          mobVersion
          groups
          appInstance
          setId
          productId
          orderNumber
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      productPackets {
        items {
          id
          mobVersion
          groups
          appInstance
          productPacketId
          productId
          orderNumber
          preselected
          required
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          article {
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            __typename
          }
          language
          languages
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
            __typename
          }
          groupCourse {
            id
            mobVersion
            appInstance
            mssId
            title
            description
            pointMeetingMssId
            dateFrom
            dateTo
            availableCapacity
            hoursPerDay
            minLength
            skillLevelClientId
            allowGroupCourseFlexibleStart
            price
            __typename
          }
          groupCourseDateStart
          groupCourseLessons {
            id
            mobVersion
            appInstance
            mssId
            timeFrom
            timeTo
            availableCapacity
            __typename
          }
          price
          priceWithoutDph
          dph
          dphPercent
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          priceListType
          createdAt
          updatedAt
          skillLevelClient {
            id
            mobVersion
            groups
            appInstance
            mssId
            name
            description
            orderNumber
            codeSkillLevelClient
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createProductPacket = /* GraphQL */ `
  mutation CreateProductPacket(
    $input: CreateProductPacketInput!
    $condition: ModelProductPacketConditionInput
  ) {
    createProductPacket(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      image
      orderNumber
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          productPacketId
          productId
          orderNumber
          preselected
          required
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateProductPacket = /* GraphQL */ `
  mutation UpdateProductPacket(
    $input: UpdateProductPacketInput!
    $condition: ModelProductPacketConditionInput
  ) {
    updateProductPacket(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      image
      orderNumber
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          productPacketId
          productId
          orderNumber
          preselected
          required
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteProductPacket = /* GraphQL */ `
  mutation DeleteProductPacket(
    $input: DeleteProductPacketInput!
    $condition: ModelProductPacketConditionInput
  ) {
    deleteProductPacket(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      image
      orderNumber
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          productPacketId
          productId
          orderNumber
          preselected
          required
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createCategory = /* GraphQL */ `
  mutation CreateCategory(
    $input: CreateCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    createCategory(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      productType
      orderNumber
      campCourse
      hidden
      rentalSet
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      sets {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          categoryId
          title
          description
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          pricingMode
          createdAt
          updatedAt
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateCategory = /* GraphQL */ `
  mutation UpdateCategory(
    $input: UpdateCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    updateCategory(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      productType
      orderNumber
      campCourse
      hidden
      rentalSet
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      sets {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          categoryId
          title
          description
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          pricingMode
          createdAt
          updatedAt
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteCategory = /* GraphQL */ `
  mutation DeleteCategory(
    $input: DeleteCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    deleteCategory(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      productType
      orderNumber
      campCourse
      hidden
      rentalSet
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      sets {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          categoryId
          title
          description
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          pricingMode
          createdAt
          updatedAt
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createProductLocation = /* GraphQL */ `
  mutation CreateProductLocation(
    $input: CreateProductLocationInput!
    $condition: ModelProductLocationConditionInput
  ) {
    createProductLocation(input: $input, condition: $condition) {
      id
      mobVersion
      productId
      locationId
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateProductLocation = /* GraphQL */ `
  mutation UpdateProductLocation(
    $input: UpdateProductLocationInput!
    $condition: ModelProductLocationConditionInput
  ) {
    updateProductLocation(input: $input, condition: $condition) {
      id
      mobVersion
      productId
      locationId
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteProductLocation = /* GraphQL */ `
  mutation DeleteProductLocation(
    $input: DeleteProductLocationInput!
    $condition: ModelProductLocationConditionInput
  ) {
    deleteProductLocation(input: $input, condition: $condition) {
      id
      mobVersion
      productId
      locationId
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createLocation = /* GraphQL */ `
  mutation CreateLocation(
    $input: CreateLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    createLocation(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      orderNumber
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          productId
          locationId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      pointSells {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      pointMeetings {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateLocation = /* GraphQL */ `
  mutation UpdateLocation(
    $input: UpdateLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    updateLocation(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      orderNumber
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          productId
          locationId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      pointSells {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      pointMeetings {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteLocation = /* GraphQL */ `
  mutation DeleteLocation(
    $input: DeleteLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    deleteLocation(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      orderNumber
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          productId
          locationId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      pointSells {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      pointMeetings {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createPointSell = /* GraphQL */ `
  mutation CreatePointSell(
    $input: CreatePointSellInput!
    $condition: ModelPointSellConditionInput
  ) {
    createPointSell(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      addressName
      addressStreet
      addressCity
      addressPostalCode
      gps
      orderNumber
      email
      note
      createdAt
      updatedAt
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      pointMeeting {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        gps
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      orderrs {
        items {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          discountCode
          language
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            age
            gender
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            __typename
          }
          payments {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updatePointSell = /* GraphQL */ `
  mutation UpdatePointSell(
    $input: UpdatePointSellInput!
    $condition: ModelPointSellConditionInput
  ) {
    updatePointSell(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      addressName
      addressStreet
      addressCity
      addressPostalCode
      gps
      orderNumber
      email
      note
      createdAt
      updatedAt
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      pointMeeting {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        gps
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      orderrs {
        items {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          discountCode
          language
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            age
            gender
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            __typename
          }
          payments {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deletePointSell = /* GraphQL */ `
  mutation DeletePointSell(
    $input: DeletePointSellInput!
    $condition: ModelPointSellConditionInput
  ) {
    deletePointSell(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      addressName
      addressStreet
      addressCity
      addressPostalCode
      gps
      orderNumber
      email
      note
      createdAt
      updatedAt
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      pointMeeting {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        gps
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      orderrs {
        items {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          discountCode
          language
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            age
            gender
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            __typename
          }
          payments {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createPointSellOpenHours = /* GraphQL */ `
  mutation CreatePointSellOpenHours(
    $input: CreatePointSellOpenHoursInput!
    $condition: ModelPointSellOpenHoursConditionInput
  ) {
    createPointSellOpenHours(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      pointSellMssId
      scheduleType
      dateFrom
      dateTo
      closedAllPeriod
      name
      scheduleScope
      scheduleSort
      createdAt
      updatedAt
      intervals {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          dayOfWeek
          intervalNo
          opens
          closes
          createdAt
          updatedAt
          openHours {
            id
            mobVersion
            groups
            appInstance
            mssId
            pointSellMssId
            scheduleType
            dateFrom
            dateTo
            closedAllPeriod
            name
            scheduleScope
            scheduleSort
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updatePointSellOpenHours = /* GraphQL */ `
  mutation UpdatePointSellOpenHours(
    $input: UpdatePointSellOpenHoursInput!
    $condition: ModelPointSellOpenHoursConditionInput
  ) {
    updatePointSellOpenHours(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      pointSellMssId
      scheduleType
      dateFrom
      dateTo
      closedAllPeriod
      name
      scheduleScope
      scheduleSort
      createdAt
      updatedAt
      intervals {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          dayOfWeek
          intervalNo
          opens
          closes
          createdAt
          updatedAt
          openHours {
            id
            mobVersion
            groups
            appInstance
            mssId
            pointSellMssId
            scheduleType
            dateFrom
            dateTo
            closedAllPeriod
            name
            scheduleScope
            scheduleSort
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deletePointSellOpenHours = /* GraphQL */ `
  mutation DeletePointSellOpenHours(
    $input: DeletePointSellOpenHoursInput!
    $condition: ModelPointSellOpenHoursConditionInput
  ) {
    deletePointSellOpenHours(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      pointSellMssId
      scheduleType
      dateFrom
      dateTo
      closedAllPeriod
      name
      scheduleScope
      scheduleSort
      createdAt
      updatedAt
      intervals {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          dayOfWeek
          intervalNo
          opens
          closes
          createdAt
          updatedAt
          openHours {
            id
            mobVersion
            groups
            appInstance
            mssId
            pointSellMssId
            scheduleType
            dateFrom
            dateTo
            closedAllPeriod
            name
            scheduleScope
            scheduleSort
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createPointSellOpenHoursInterval = /* GraphQL */ `
  mutation CreatePointSellOpenHoursInterval(
    $input: CreatePointSellOpenHoursIntervalInput!
    $condition: ModelPointSellOpenHoursIntervalConditionInput
  ) {
    createPointSellOpenHoursInterval(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      dayOfWeek
      intervalNo
      opens
      closes
      createdAt
      updatedAt
      openHours {
        id
        mobVersion
        groups
        appInstance
        mssId
        pointSellMssId
        scheduleType
        dateFrom
        dateTo
        closedAllPeriod
        name
        scheduleScope
        scheduleSort
        createdAt
        updatedAt
        intervals {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            dayOfWeek
            intervalNo
            opens
            closes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updatePointSellOpenHoursInterval = /* GraphQL */ `
  mutation UpdatePointSellOpenHoursInterval(
    $input: UpdatePointSellOpenHoursIntervalInput!
    $condition: ModelPointSellOpenHoursIntervalConditionInput
  ) {
    updatePointSellOpenHoursInterval(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      dayOfWeek
      intervalNo
      opens
      closes
      createdAt
      updatedAt
      openHours {
        id
        mobVersion
        groups
        appInstance
        mssId
        pointSellMssId
        scheduleType
        dateFrom
        dateTo
        closedAllPeriod
        name
        scheduleScope
        scheduleSort
        createdAt
        updatedAt
        intervals {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            dayOfWeek
            intervalNo
            opens
            closes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deletePointSellOpenHoursInterval = /* GraphQL */ `
  mutation DeletePointSellOpenHoursInterval(
    $input: DeletePointSellOpenHoursIntervalInput!
    $condition: ModelPointSellOpenHoursIntervalConditionInput
  ) {
    deletePointSellOpenHoursInterval(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      dayOfWeek
      intervalNo
      opens
      closes
      createdAt
      updatedAt
      openHours {
        id
        mobVersion
        groups
        appInstance
        mssId
        pointSellMssId
        scheduleType
        dateFrom
        dateTo
        closedAllPeriod
        name
        scheduleScope
        scheduleSort
        createdAt
        updatedAt
        intervals {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            dayOfWeek
            intervalNo
            opens
            closes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createProductAvailabilityInterval = /* GraphQL */ `
  mutation CreateProductAvailabilityInterval(
    $input: CreateProductAvailabilityIntervalInput!
    $condition: ModelProductAvailabilityIntervalConditionInput
  ) {
    createProductAvailabilityInterval(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      productMssId
      productId
      name
      dateFrom
      dateTo
      availabilityPercent
      productScope
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProductAvailabilityInterval = /* GraphQL */ `
  mutation UpdateProductAvailabilityInterval(
    $input: UpdateProductAvailabilityIntervalInput!
    $condition: ModelProductAvailabilityIntervalConditionInput
  ) {
    updateProductAvailabilityInterval(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      productMssId
      productId
      name
      dateFrom
      dateTo
      availabilityPercent
      productScope
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProductAvailabilityInterval = /* GraphQL */ `
  mutation DeleteProductAvailabilityInterval(
    $input: DeleteProductAvailabilityIntervalInput!
    $condition: ModelProductAvailabilityIntervalConditionInput
  ) {
    deleteProductAvailabilityInterval(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      productMssId
      productId
      name
      dateFrom
      dateTo
      availabilityPercent
      productScope
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPointMeeting = /* GraphQL */ `
  mutation CreatePointMeeting(
    $input: CreatePointMeetingInput!
    $condition: ModelPointMeetingConditionInput
  ) {
    createPointMeeting(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      orderNumber
      gps
      createdAt
      updatedAt
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        orderNumber
        email
        note
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          pointMeetingId
          productId
          orderNumber
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updatePointMeeting = /* GraphQL */ `
  mutation UpdatePointMeeting(
    $input: UpdatePointMeetingInput!
    $condition: ModelPointMeetingConditionInput
  ) {
    updatePointMeeting(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      orderNumber
      gps
      createdAt
      updatedAt
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        orderNumber
        email
        note
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          pointMeetingId
          productId
          orderNumber
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deletePointMeeting = /* GraphQL */ `
  mutation DeletePointMeeting(
    $input: DeletePointMeetingInput!
    $condition: ModelPointMeetingConditionInput
  ) {
    deletePointMeeting(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      orderNumber
      gps
      createdAt
      updatedAt
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        orderNumber
        email
        note
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          pointMeetingId
          productId
          orderNumber
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createSet = /* GraphQL */ `
  mutation CreateSet(
    $input: CreateSetInput!
    $condition: ModelSetConditionInput
  ) {
    createSet(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      categoryId
      title
      description
      priceTables {
        mssId
        numberOfPersons
        priceListType
        isLowSeason
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
        __typename
      }
      pricingMode
      createdAt
      updatedAt
      category {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        orderNumber
        campCourse
        hidden
        rentalSet
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          setId
          productId
          orderNumber
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateSet = /* GraphQL */ `
  mutation UpdateSet(
    $input: UpdateSetInput!
    $condition: ModelSetConditionInput
  ) {
    updateSet(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      categoryId
      title
      description
      priceTables {
        mssId
        numberOfPersons
        priceListType
        isLowSeason
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
        __typename
      }
      pricingMode
      createdAt
      updatedAt
      category {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        orderNumber
        campCourse
        hidden
        rentalSet
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          setId
          productId
          orderNumber
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteSet = /* GraphQL */ `
  mutation DeleteSet(
    $input: DeleteSetInput!
    $condition: ModelSetConditionInput
  ) {
    deleteSet(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      categoryId
      title
      description
      priceTables {
        mssId
        numberOfPersons
        priceListType
        isLowSeason
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
        __typename
      }
      pricingMode
      createdAt
      updatedAt
      category {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        orderNumber
        campCourse
        hidden
        rentalSet
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          setId
          productId
          orderNumber
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createProductPointMeeting = /* GraphQL */ `
  mutation CreateProductPointMeeting(
    $input: CreateProductPointMeetingInput!
    $condition: ModelProductPointMeetingConditionInput
  ) {
    createProductPointMeeting(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      pointMeetingId
      productId
      orderNumber
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      pointMeeting {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        gps
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateProductPointMeeting = /* GraphQL */ `
  mutation UpdateProductPointMeeting(
    $input: UpdateProductPointMeetingInput!
    $condition: ModelProductPointMeetingConditionInput
  ) {
    updateProductPointMeeting(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      pointMeetingId
      productId
      orderNumber
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      pointMeeting {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        gps
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteProductPointMeeting = /* GraphQL */ `
  mutation DeleteProductPointMeeting(
    $input: DeleteProductPointMeetingInput!
    $condition: ModelProductPointMeetingConditionInput
  ) {
    deleteProductPointMeeting(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      pointMeetingId
      productId
      orderNumber
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      pointMeeting {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        gps
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createSetProduct = /* GraphQL */ `
  mutation CreateSetProduct(
    $input: CreateSetProductInput!
    $condition: ModelSetProductConditionInput
  ) {
    createSetProduct(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      setId
      productId
      orderNumber
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      set {
        id
        mobVersion
        groups
        appInstance
        mssId
        categoryId
        title
        description
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        pricingMode
        createdAt
        updatedAt
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateSetProduct = /* GraphQL */ `
  mutation UpdateSetProduct(
    $input: UpdateSetProductInput!
    $condition: ModelSetProductConditionInput
  ) {
    updateSetProduct(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      setId
      productId
      orderNumber
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      set {
        id
        mobVersion
        groups
        appInstance
        mssId
        categoryId
        title
        description
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        pricingMode
        createdAt
        updatedAt
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteSetProduct = /* GraphQL */ `
  mutation DeleteSetProduct(
    $input: DeleteSetProductInput!
    $condition: ModelSetProductConditionInput
  ) {
    deleteSetProduct(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      setId
      productId
      orderNumber
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      set {
        id
        mobVersion
        groups
        appInstance
        mssId
        categoryId
        title
        description
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        pricingMode
        createdAt
        updatedAt
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createProductPacketProduct = /* GraphQL */ `
  mutation CreateProductPacketProduct(
    $input: CreateProductPacketProductInput!
    $condition: ModelProductPacketProductConditionInput
  ) {
    createProductPacketProduct(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      productPacketId
      productId
      orderNumber
      preselected
      required
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      productPacket {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        image
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateProductPacketProduct = /* GraphQL */ `
  mutation UpdateProductPacketProduct(
    $input: UpdateProductPacketProductInput!
    $condition: ModelProductPacketProductConditionInput
  ) {
    updateProductPacketProduct(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      productPacketId
      productId
      orderNumber
      preselected
      required
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      productPacket {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        image
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteProductPacketProduct = /* GraphQL */ `
  mutation DeleteProductPacketProduct(
    $input: DeleteProductPacketProductInput!
    $condition: ModelProductPacketProductConditionInput
  ) {
    deleteProductPacketProduct(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      productPacketId
      productId
      orderNumber
      preselected
      required
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      productPacket {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        image
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createSubject = /* GraphQL */ `
  mutation CreateSubject(
    $input: CreateSubjectInput!
    $condition: ModelSubjectConditionInput
  ) {
    createSubject(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      cognitoId
      companyName
      name
      surname
      age
      gender
      street
      city
      postalCode
      country
      email
      phone
      nationality
      documentType
      documentNumber
      documentValidTo
      ic
      dic
      createdAt
      updatedAt
      orderrs {
        items {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          discountCode
          language
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            age
            gender
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            __typename
          }
          payments {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateSubject = /* GraphQL */ `
  mutation UpdateSubject(
    $input: UpdateSubjectInput!
    $condition: ModelSubjectConditionInput
  ) {
    updateSubject(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      cognitoId
      companyName
      name
      surname
      age
      gender
      street
      city
      postalCode
      country
      email
      phone
      nationality
      documentType
      documentNumber
      documentValidTo
      ic
      dic
      createdAt
      updatedAt
      orderrs {
        items {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          discountCode
          language
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            age
            gender
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            __typename
          }
          payments {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteSubject = /* GraphQL */ `
  mutation DeleteSubject(
    $input: DeleteSubjectInput!
    $condition: ModelSubjectConditionInput
  ) {
    deleteSubject(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      cognitoId
      companyName
      name
      surname
      age
      gender
      street
      city
      postalCode
      country
      email
      phone
      nationality
      documentType
      documentNumber
      documentValidTo
      ic
      dic
      createdAt
      updatedAt
      orderrs {
        items {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          discountCode
          language
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            age
            gender
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            __typename
          }
          payments {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createPayment = /* GraphQL */ `
  mutation CreatePayment(
    $input: CreatePaymentInput!
    $condition: ModelPaymentConditionInput
  ) {
    createPayment(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      mssOrderrId
      paymentMethod
      paymentState
      amount
      currency
      transId
      redirectUrl
      expirationNotified
      createdAt
      updatedAt
      orderr {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        discountCode
        language
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          age
          gender
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            expirationNotified
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updatePayment = /* GraphQL */ `
  mutation UpdatePayment(
    $input: UpdatePaymentInput!
    $condition: ModelPaymentConditionInput
  ) {
    updatePayment(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      mssOrderrId
      paymentMethod
      paymentState
      amount
      currency
      transId
      redirectUrl
      expirationNotified
      createdAt
      updatedAt
      orderr {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        discountCode
        language
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          age
          gender
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            expirationNotified
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deletePayment = /* GraphQL */ `
  mutation DeletePayment(
    $input: DeletePaymentInput!
    $condition: ModelPaymentConditionInput
  ) {
    deletePayment(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      mssOrderrId
      paymentMethod
      paymentState
      amount
      currency
      transId
      redirectUrl
      expirationNotified
      createdAt
      updatedAt
      orderr {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        discountCode
        language
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          age
          gender
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            expirationNotified
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createOrderr = /* GraphQL */ `
  mutation CreateOrderr(
    $input: CreateOrderrInput!
    $condition: ModelOrderrConditionInput
  ) {
    createOrderr(input: $input, condition: $condition) {
      id
      mssId
      mobVersion
      groups
      appInstance
      bookingState
      orderrNumber
      price
      priceWithoutDph
      dph
      deposit
      itemsCount
      expireAt
      datePickUp
      dateReturn
      dateTryOut
      paymentMethod
      description
      rentDiscountPercent
      schoolDiscountPercent
      discountCode
      language
      createdAt
      updatedAt
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        orderNumber
        email
        note
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      client {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        age
        gender
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      payments {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          mssOrderrId
          paymentMethod
          paymentState
          amount
          currency
          transId
          redirectUrl
          expirationNotified
          createdAt
          updatedAt
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateOrderr = /* GraphQL */ `
  mutation UpdateOrderr(
    $input: UpdateOrderrInput!
    $condition: ModelOrderrConditionInput
  ) {
    updateOrderr(input: $input, condition: $condition) {
      id
      mssId
      mobVersion
      groups
      appInstance
      bookingState
      orderrNumber
      price
      priceWithoutDph
      dph
      deposit
      itemsCount
      expireAt
      datePickUp
      dateReturn
      dateTryOut
      paymentMethod
      description
      rentDiscountPercent
      schoolDiscountPercent
      discountCode
      language
      createdAt
      updatedAt
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        orderNumber
        email
        note
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      client {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        age
        gender
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      payments {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          mssOrderrId
          paymentMethod
          paymentState
          amount
          currency
          transId
          redirectUrl
          expirationNotified
          createdAt
          updatedAt
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteOrderr = /* GraphQL */ `
  mutation DeleteOrderr(
    $input: DeleteOrderrInput!
    $condition: ModelOrderrConditionInput
  ) {
    deleteOrderr(input: $input, condition: $condition) {
      id
      mssId
      mobVersion
      groups
      appInstance
      bookingState
      orderrNumber
      price
      priceWithoutDph
      dph
      deposit
      itemsCount
      expireAt
      datePickUp
      dateReturn
      dateTryOut
      paymentMethod
      description
      rentDiscountPercent
      schoolDiscountPercent
      discountCode
      language
      createdAt
      updatedAt
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        orderNumber
        email
        note
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      client {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        age
        gender
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      payments {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          mssOrderrId
          paymentMethod
          paymentState
          amount
          currency
          transId
          redirectUrl
          expirationNotified
          createdAt
          updatedAt
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createOrderrItemGroup = /* GraphQL */ `
  mutation CreateOrderrItemGroup(
    $input: CreateOrderrItemGroupInput!
    $condition: ModelOrderrItemGroupConditionInput
  ) {
    createOrderrItemGroup(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      subjectProfiles {
        name
        surname
        weight
        height
        shoeSize
        age
        birthDate
        gender
        rentAbilityLevel
        schoolSkillLevelClientId
        note
        language
        customFormData
        __typename
      }
      description
      orderrItemGroupPointSellId
      itemsCount
      numberOfPersons
      length
      priceListType
      alternativePriceTable {
        mssId
        numberOfPersons
        priceListType
        isLowSeason
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
        __typename
      }
      dateStart
      dateEnd
      datePickUp
      dateReturn
      dateTryOut
      price
      priceWithoutDph
      priceBeforeDiscount
      priceBeforeDiscountWithoutDph
      discountPercent
      dph
      dphPercent
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      productPacket {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        image
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        orderNumber
        email
        note
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      pointMeeting {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        gps
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      set {
        id
        mobVersion
        groups
        appInstance
        mssId
        categoryId
        title
        description
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        pricingMode
        createdAt
        updatedAt
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      orderr {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        discountCode
        language
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          age
          gender
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            expirationNotified
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          article {
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            __typename
          }
          language
          languages
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
            __typename
          }
          groupCourse {
            id
            mobVersion
            appInstance
            mssId
            title
            description
            pointMeetingMssId
            dateFrom
            dateTo
            availableCapacity
            hoursPerDay
            minLength
            skillLevelClientId
            allowGroupCourseFlexibleStart
            price
            __typename
          }
          groupCourseDateStart
          groupCourseLessons {
            id
            mobVersion
            appInstance
            mssId
            timeFrom
            timeTo
            availableCapacity
            __typename
          }
          price
          priceWithoutDph
          dph
          dphPercent
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          priceListType
          createdAt
          updatedAt
          skillLevelClient {
            id
            mobVersion
            groups
            appInstance
            mssId
            name
            description
            orderNumber
            codeSkillLevelClient
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateOrderrItemGroup = /* GraphQL */ `
  mutation UpdateOrderrItemGroup(
    $input: UpdateOrderrItemGroupInput!
    $condition: ModelOrderrItemGroupConditionInput
  ) {
    updateOrderrItemGroup(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      subjectProfiles {
        name
        surname
        weight
        height
        shoeSize
        age
        birthDate
        gender
        rentAbilityLevel
        schoolSkillLevelClientId
        note
        language
        customFormData
        __typename
      }
      description
      orderrItemGroupPointSellId
      itemsCount
      numberOfPersons
      length
      priceListType
      alternativePriceTable {
        mssId
        numberOfPersons
        priceListType
        isLowSeason
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
        __typename
      }
      dateStart
      dateEnd
      datePickUp
      dateReturn
      dateTryOut
      price
      priceWithoutDph
      priceBeforeDiscount
      priceBeforeDiscountWithoutDph
      discountPercent
      dph
      dphPercent
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      productPacket {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        image
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        orderNumber
        email
        note
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      pointMeeting {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        gps
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      set {
        id
        mobVersion
        groups
        appInstance
        mssId
        categoryId
        title
        description
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        pricingMode
        createdAt
        updatedAt
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      orderr {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        discountCode
        language
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          age
          gender
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            expirationNotified
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          article {
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            __typename
          }
          language
          languages
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
            __typename
          }
          groupCourse {
            id
            mobVersion
            appInstance
            mssId
            title
            description
            pointMeetingMssId
            dateFrom
            dateTo
            availableCapacity
            hoursPerDay
            minLength
            skillLevelClientId
            allowGroupCourseFlexibleStart
            price
            __typename
          }
          groupCourseDateStart
          groupCourseLessons {
            id
            mobVersion
            appInstance
            mssId
            timeFrom
            timeTo
            availableCapacity
            __typename
          }
          price
          priceWithoutDph
          dph
          dphPercent
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          priceListType
          createdAt
          updatedAt
          skillLevelClient {
            id
            mobVersion
            groups
            appInstance
            mssId
            name
            description
            orderNumber
            codeSkillLevelClient
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteOrderrItemGroup = /* GraphQL */ `
  mutation DeleteOrderrItemGroup(
    $input: DeleteOrderrItemGroupInput!
    $condition: ModelOrderrItemGroupConditionInput
  ) {
    deleteOrderrItemGroup(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      subjectProfiles {
        name
        surname
        weight
        height
        shoeSize
        age
        birthDate
        gender
        rentAbilityLevel
        schoolSkillLevelClientId
        note
        language
        customFormData
        __typename
      }
      description
      orderrItemGroupPointSellId
      itemsCount
      numberOfPersons
      length
      priceListType
      alternativePriceTable {
        mssId
        numberOfPersons
        priceListType
        isLowSeason
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
        __typename
      }
      dateStart
      dateEnd
      datePickUp
      dateReturn
      dateTryOut
      price
      priceWithoutDph
      priceBeforeDiscount
      priceBeforeDiscountWithoutDph
      discountPercent
      dph
      dphPercent
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      productPacket {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        image
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        orderNumber
        email
        note
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      pointMeeting {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        gps
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      set {
        id
        mobVersion
        groups
        appInstance
        mssId
        categoryId
        title
        description
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        pricingMode
        createdAt
        updatedAt
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      orderr {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        discountCode
        language
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          age
          gender
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            expirationNotified
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          article {
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            __typename
          }
          language
          languages
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
            __typename
          }
          groupCourse {
            id
            mobVersion
            appInstance
            mssId
            title
            description
            pointMeetingMssId
            dateFrom
            dateTo
            availableCapacity
            hoursPerDay
            minLength
            skillLevelClientId
            allowGroupCourseFlexibleStart
            price
            __typename
          }
          groupCourseDateStart
          groupCourseLessons {
            id
            mobVersion
            appInstance
            mssId
            timeFrom
            timeTo
            availableCapacity
            __typename
          }
          price
          priceWithoutDph
          dph
          dphPercent
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          priceListType
          createdAt
          updatedAt
          skillLevelClient {
            id
            mobVersion
            groups
            appInstance
            mssId
            name
            description
            orderNumber
            codeSkillLevelClient
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createOrderrItem = /* GraphQL */ `
  mutation CreateOrderrItem(
    $input: CreateOrderrItemInput!
    $condition: ModelOrderrItemConditionInput
  ) {
    createOrderrItem(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      article {
        mssId
        articleType
        productId
        pointSellId
        title
        description
        articleCountTotal
        articleNumber
        articleNumber2
        size
        sizeUnit
        rentLevel
        rentAgeGroup
        rentGender
        aggItem
        __typename
      }
      language
      languages
      sameInstructorRequired
      numberOfHoursRequired
      lessons {
        mobVersion
        groups
        appInstance
        mssId
        timeFrom
        timeTo
        timeLength
        mssWorkDayId
        __typename
      }
      groupCourse {
        id
        mobVersion
        appInstance
        mssId
        title
        description
        pointMeetingMssId
        dateFrom
        dateTo
        availableCapacity
        hoursPerDay
        minLength
        skillLevelClientId
        allowGroupCourseFlexibleStart
        price
        __typename
      }
      groupCourseDateStart
      groupCourseLessons {
        id
        mobVersion
        appInstance
        mssId
        timeFrom
        timeTo
        availableCapacity
        __typename
      }
      price
      priceWithoutDph
      dph
      dphPercent
      priceBeforeDiscount
      priceBeforeDiscountWithoutDph
      discountPercent
      priceListType
      createdAt
      updatedAt
      skillLevelClient {
        id
        mobVersion
        groups
        appInstance
        mssId
        name
        description
        orderNumber
        codeSkillLevelClient
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      orderrItemGroup {
        id
        mobVersion
        groups
        appInstance
        mssId
        subjectProfiles {
          name
          surname
          weight
          height
          shoeSize
          age
          birthDate
          gender
          rentAbilityLevel
          schoolSkillLevelClientId
          note
          language
          customFormData
          __typename
        }
        description
        orderrItemGroupPointSellId
        itemsCount
        numberOfPersons
        length
        priceListType
        alternativePriceTable {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        dateStart
        dateEnd
        datePickUp
        dateReturn
        dateTryOut
        price
        priceWithoutDph
        priceBeforeDiscount
        priceBeforeDiscountWithoutDph
        discountPercent
        dph
        dphPercent
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        productPacket {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          image
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        set {
          id
          mobVersion
          groups
          appInstance
          mssId
          categoryId
          title
          description
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          pricingMode
          createdAt
          updatedAt
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderr {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          discountCode
          language
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            age
            gender
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            __typename
          }
          payments {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateOrderrItem = /* GraphQL */ `
  mutation UpdateOrderrItem(
    $input: UpdateOrderrItemInput!
    $condition: ModelOrderrItemConditionInput
  ) {
    updateOrderrItem(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      article {
        mssId
        articleType
        productId
        pointSellId
        title
        description
        articleCountTotal
        articleNumber
        articleNumber2
        size
        sizeUnit
        rentLevel
        rentAgeGroup
        rentGender
        aggItem
        __typename
      }
      language
      languages
      sameInstructorRequired
      numberOfHoursRequired
      lessons {
        mobVersion
        groups
        appInstance
        mssId
        timeFrom
        timeTo
        timeLength
        mssWorkDayId
        __typename
      }
      groupCourse {
        id
        mobVersion
        appInstance
        mssId
        title
        description
        pointMeetingMssId
        dateFrom
        dateTo
        availableCapacity
        hoursPerDay
        minLength
        skillLevelClientId
        allowGroupCourseFlexibleStart
        price
        __typename
      }
      groupCourseDateStart
      groupCourseLessons {
        id
        mobVersion
        appInstance
        mssId
        timeFrom
        timeTo
        availableCapacity
        __typename
      }
      price
      priceWithoutDph
      dph
      dphPercent
      priceBeforeDiscount
      priceBeforeDiscountWithoutDph
      discountPercent
      priceListType
      createdAt
      updatedAt
      skillLevelClient {
        id
        mobVersion
        groups
        appInstance
        mssId
        name
        description
        orderNumber
        codeSkillLevelClient
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      orderrItemGroup {
        id
        mobVersion
        groups
        appInstance
        mssId
        subjectProfiles {
          name
          surname
          weight
          height
          shoeSize
          age
          birthDate
          gender
          rentAbilityLevel
          schoolSkillLevelClientId
          note
          language
          customFormData
          __typename
        }
        description
        orderrItemGroupPointSellId
        itemsCount
        numberOfPersons
        length
        priceListType
        alternativePriceTable {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        dateStart
        dateEnd
        datePickUp
        dateReturn
        dateTryOut
        price
        priceWithoutDph
        priceBeforeDiscount
        priceBeforeDiscountWithoutDph
        discountPercent
        dph
        dphPercent
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        productPacket {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          image
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        set {
          id
          mobVersion
          groups
          appInstance
          mssId
          categoryId
          title
          description
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          pricingMode
          createdAt
          updatedAt
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderr {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          discountCode
          language
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            age
            gender
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            __typename
          }
          payments {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteOrderrItem = /* GraphQL */ `
  mutation DeleteOrderrItem(
    $input: DeleteOrderrItemInput!
    $condition: ModelOrderrItemConditionInput
  ) {
    deleteOrderrItem(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      article {
        mssId
        articleType
        productId
        pointSellId
        title
        description
        articleCountTotal
        articleNumber
        articleNumber2
        size
        sizeUnit
        rentLevel
        rentAgeGroup
        rentGender
        aggItem
        __typename
      }
      language
      languages
      sameInstructorRequired
      numberOfHoursRequired
      lessons {
        mobVersion
        groups
        appInstance
        mssId
        timeFrom
        timeTo
        timeLength
        mssWorkDayId
        __typename
      }
      groupCourse {
        id
        mobVersion
        appInstance
        mssId
        title
        description
        pointMeetingMssId
        dateFrom
        dateTo
        availableCapacity
        hoursPerDay
        minLength
        skillLevelClientId
        allowGroupCourseFlexibleStart
        price
        __typename
      }
      groupCourseDateStart
      groupCourseLessons {
        id
        mobVersion
        appInstance
        mssId
        timeFrom
        timeTo
        availableCapacity
        __typename
      }
      price
      priceWithoutDph
      dph
      dphPercent
      priceBeforeDiscount
      priceBeforeDiscountWithoutDph
      discountPercent
      priceListType
      createdAt
      updatedAt
      skillLevelClient {
        id
        mobVersion
        groups
        appInstance
        mssId
        name
        description
        orderNumber
        codeSkillLevelClient
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      orderrItemGroup {
        id
        mobVersion
        groups
        appInstance
        mssId
        subjectProfiles {
          name
          surname
          weight
          height
          shoeSize
          age
          birthDate
          gender
          rentAbilityLevel
          schoolSkillLevelClientId
          note
          language
          customFormData
          __typename
        }
        description
        orderrItemGroupPointSellId
        itemsCount
        numberOfPersons
        length
        priceListType
        alternativePriceTable {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        dateStart
        dateEnd
        datePickUp
        dateReturn
        dateTryOut
        price
        priceWithoutDph
        priceBeforeDiscount
        priceBeforeDiscountWithoutDph
        discountPercent
        dph
        dphPercent
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        productPacket {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          image
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        set {
          id
          mobVersion
          groups
          appInstance
          mssId
          categoryId
          title
          description
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          pricingMode
          createdAt
          updatedAt
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderr {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          discountCode
          language
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            age
            gender
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            __typename
          }
          payments {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
